export default __webpack_public_path__ + "static/media/link.47077df4.svg";